import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchEmployeeCount = createAsyncThunk(
  "employeeCount/fetchEmployeeCount",
  async (filters = {}, { getState, rejectWithValue }) => {
    try {
      const { accessToken } = getState().auth;

      const { 
        companyId, 
        branchId, 
        roleId, 
 
        status,        
        assignmentType 
      } = filters;

      const params = {};

      if (branchId && branchId !== 'All') params.branchId = branchId;
      if (roleId && roleId !== 'All') params.roleId = roleId;

      if (status && status !== "All") {
        params.status = status;
      }

      if (assignmentType && assignmentType.toLowerCase() !== "both" && assignmentType !== "All") {
        params.assignmentType = assignmentType;
      }

   
       let url = `${API_URL}/employee/by-company/${companyId}/count`;

      console.log(
        `📡 Fetching Count URL: ${url} with params:`,
        JSON.stringify(params)
      );

      const response = await axios.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      console.log("Count Response Data:", response.data);
      return response.data;
    } catch (err) {
      console.log(err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch employee count";
      return rejectWithValue(errorMessage);
    }
  },
);

const employeeCountSlice = createSlice({
  name: "employeeCount",
  initialState: {
    count: 0,
    status: "idle",
    error: null,
  },
  reducers: {
    clearCountError: (state) => {
      state.error = null;
    },
    resetCount: (state) => {
      state.count = 0;
      state.status = "idle";
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeCount.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployeeCount.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.count = typeof action.payload === 'object' ? action.payload.count : action.payload;
      })
      .addCase(fetchEmployeeCount.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearCountError, resetCount } = employeeCountSlice.actions;

export default employeeCountSlice.reducer;